import { MantineProvider } from '@mantine/core';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import '@mantine/core/styles.css';
import { AppErrorBoundary } from '../../components/BaseErrorBoundary';
import { DigitalMenuPage } from './DigitalMenuPage';

export function PublicMenuEntry() {
  return <MantineProvider defaultColorScheme="light"><AppErrorBoundary><BrowserRouter><Routes>
    <Route path="/menu/:tenantId" element={<DigitalMenuPage />} />
    <Route path="*" element={<main dir="rtl"><h1>התפריט אינו זמין כרגע</h1></main>} />
  </Routes></BrowserRouter></AppErrorBoundary></MantineProvider>;
}